import React from 'react'

import { LntButton, LntModal, LntModalFooter, LntForm, LntFormItem, LntRangeDatePicker } from '@app/components/base'
import { getTodayDate, getTomorrowDate } from '@app/utils/date'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import type { CommonExportLogReportModalProps } from './types'
import type { LogReportData } from '@app/pages/CheckingPricesCompetitorsPage/types'

export const CommonExportLogReportModal: React.FC<CommonExportLogReportModalProps> = props => {
  const { onSubmit, loading, ...restProps } = props

  const handleSubmit = (data: LogReportData): void => {
    onSubmit(data)
  }

  return (
    <LntModal
      { ...restProps }
      title='Настройка экспорта'
      footer={ null }
      width={ 445 }
    >
      <LntForm
        layout='vertical'
        onSubmit={ handleSubmit }
      >
        <LntFormItem
          name='periodDate'
          label='Выберите период'
          defaultValue={ [getTodayDate(), getTomorrowDate()] }
        >
          <LntRangeDatePicker size={ SIZE.large } />
        </LntFormItem>

        <LntModalFooter>
          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
            loading={ loading }
          >
            Экспортировать
          </LntButton>
        </LntModalFooter>
      </LntForm>
    </LntModal>
  )
}
